<div
  class="property-top"
  [ngStyle]="{'background-image': 'url(' + apartmentType.images[0].width_560_url + ')'}"
>
  <img
    *ngIf="apartmentType.available_properties_count == 0"
    class="property-sold"
    src="/assets/icons/sold-out.png"
    alt="vândut"
  >
</div>
<div class="property-bottom" fxLayout="column" fxLayoutAlign="center">
  <div
    fxLayoutAlign="center center"
    class="price-tag"
  >
    <h3>
      {{ apartmentType.title }}
    </h3>
  </div>
  <div fxLayout="column" fxLayoutAlign="space-between" class="property-bottom-content">
    <h5>
      <span>
        {{ 'pages.house_details.property_description.properties_count' | translate }}
      </span>
      {{ apartmentType.properties_count }}
    </h5>
    <h5
      *ngIf="apartmentType.available_properties_count"
      class="available"
    >
      <span>
        {{ 'pages.house_details.property_description.available_properties_count' | translate }}
      </span>
      {{ apartmentType.available_properties_count }}
    </h5>
    <h5 *ngIf="apartmentType.sale_price">
      <strong *ngIf="apartmentType.sale_price">
        {{ apartmentType.sale_price | number:'.0' }} {{ 'model.currency_id.' + apartmentType.currency_id | translate }}
      </strong>
      <strong *ngIf="apartmentType.max_sale_price && apartmentType.max_sale_price > apartmentType.sale_price">
        - {{ apartmentType.max_sale_price | number:'.0' }} {{ 'model.currency_id.' + apartmentType.currency_id | translate }}
      </strong>
      + TVA
    </h5>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="property-characteristics"
    >
      <div fxFlex="23%" class="pc-item room-count-item">
        <div class="pc-item-content">
          {{ apartmentType.room_count }}
        </div>
      </div>
      <div fxFlex="23%" class="pc-item bathroom-count-item">
        <div class="pc-item-content">
          {{ apartmentType.bathroom_count }}
        </div>
      </div>
      <div fxFlex="23%" class="pc-item">
        <div class="pc-item-content">
          {{ apartmentType.usable_size_sqm | number:'.2' }} m<sup>2</sup>
        </div>
      </div>
      <div fxFlex="33%" class="pc-item details">
        <div class="pc-item-content">
          {{ apartmentType.type_name }}
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/my-apartment-type/my-apartment-type.component.html